import * as React from 'react';

import { CommandBar, CommandBarAction, Toaster } from '@rematter/ui-web';
import { type ComplexKeyboardShortcut } from '@rematter/ui-web/types';

import AppRouter from './AppRouter';
import { TalkJSProvider } from './contexts/TalkJSContext';

import { GlobalLoadingOverlay } from '~/shared/components/GlobalLoadingOverlay';
import { ApiProvider } from '~/shared/providers/api';
import { IdentityProvider } from '~/shared/providers/auth/IdentityProvider';
import { Libp2pProvider } from '~/shared/providers/libp2p';
import { PreferencesProvider } from '~/shared/providers/preferences';
import { PresenceProvider } from '~/shared/providers/presence';
import { TelemetryProvider } from '~/shared/providers/telemetry';
import { UStudioProvider } from '~/shared/providers/ustudio';

const actions: CommandBarAction[] = [
  {
    id: 'crm/accounts',
    label: 'Accounts',
  },
];

export function App() {
  const [isCommandBarOpen, setCommandBarOpen] = React.useState(false);

  return (
    <TelemetryProvider>
      <IdentityProvider>
        <ApiProvider>
          <TalkJSProvider>
            <Libp2pProvider>
              <PresenceProvider>
                <PreferencesProvider>
                  <UStudioProvider>
                    <Toaster closeButton />
                    <CommandBar
                      actions={actions}
                      onAction={() => {
                        /* nop */
                      }}
                      isOpen={isCommandBarOpen}
                      onOpenChange={setCommandBarOpen}
                      keyboardShortcut={'Cmd+K' as ComplexKeyboardShortcut}
                    />
                    <GlobalLoadingOverlay />
                    <AppRouter />
                  </UStudioProvider>
                </PreferencesProvider>
              </PresenceProvider>
            </Libp2pProvider>
          </TalkJSProvider>
        </ApiProvider>
      </IdentityProvider>
    </TelemetryProvider>
  );
}

export default App;
